import { gql as e } from "@apollo/client";
const t = e`
  mutation SendEmailRegisterOTP($email: String!) {
    sendEmailRegisterOTP(input: { email: $email })
  }
`;
export {
  t as default
};
//# sourceMappingURL=sendEmailRegisterOTP.js.map
